import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  GET_FEATURES_AVAILABLE,
  GET_FEATURES_AVAILABLE_SUCCESS,
  GET_CLIENT_CONFIG,
  GET_CLIENT_CONFIG_SUCCESS,
  GET_USER_PERMISSIONS,
  GET_USER_PERMISSIONS_SUCCESS,
  ENSURE_AUTH_USER,
  SWITCH_CLIENT,
  SWITCH_CLIENT_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  UPDATE_AUTH_USER_DATA,
  SET_2FA_TOKEN,
  VALIDATE_2FA,
  VALIDATE_2FA_SUCCESS,
  VALIDATE_2FA_FAILED,
  RESEND_2FA_CODE,
  RESEND_2FA_CODE_SUCCESS,
  RESEND_2FA_CODE_FAILED,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = (user, vendorId) => {
  return {
    type: LOGIN_SUCCESS,
    payload: { user: user, vendorId: vendorId },
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const getFeaturesAvailable = token => {
  return {
    type: GET_FEATURES_AVAILABLE,
    payload: token,
  }
}

export const getFeaturesAvailableSuccess = values => {
  return {
    type: GET_FEATURES_AVAILABLE_SUCCESS,
    payload: values,
  }
}

export const getUserPermissions = token => {
  return {
    type: GET_USER_PERMISSIONS,
    payload: token,
  }
}

export const getUserPermissionsSuccess = values => {
  return {
    type: GET_USER_PERMISSIONS_SUCCESS,
    payload: values,
  }
}

export const getClientConfig = token => {
  return {
    type: GET_CLIENT_CONFIG,
    payload: token,
  }
}

export const getClientConfigSuccess = values => {
  return {
    type: GET_CLIENT_CONFIG_SUCCESS,
    payload: values,
  }
}

export const switchClient = (clientId, history) => {
  return {
    type: SWITCH_CLIENT,
    payload: { clientId, history },
  }
}

export const switchClientSuccess = values => {
  return {
    type: SWITCH_CLIENT_SUCCESS,
    payload: values,
  }
}

export const ensureAuthUserData = () => {
  return {
    type: ENSURE_AUTH_USER,
    payload: {},
  }
}

export const resetPassword = (user, history) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, history },
  }
}

export const resetPasswordSuccess = (user, vendorId) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: { user: user, vendorId: vendorId },
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

export const updateAuthUserData = params => ({
  type: UPDATE_AUTH_USER_DATA,
  payload: params,
})

export const set2FaToken = params => ({
  type: SET_2FA_TOKEN,
  payload: params,
})

export const validate2Fa = (params, history) => ({
  type: VALIDATE_2FA,
  payload: { params, history },
})

export const validate2FaSuccess = response => ({
  type: VALIDATE_2FA_SUCCESS,
  payload: response,
})

export const validate2FaFailed = error => ({
  type: VALIDATE_2FA_FAILED,
  payload: error,
})

export const resend2FaCode = params => ({
  type: RESEND_2FA_CODE,
  payload: params,
})

export const resend2FaCodeSuccess = response => ({
  type: RESEND_2FA_CODE_SUCCESS,
  payload: response,
})

export const resend2FaCodeFailed = error => ({
  type: RESEND_2FA_CODE_FAILED,
  payload: error,
})
